export const SET_SENSORS_VALUES = 'SET_SENSORS_VALUES';
export const SET_SENSORS_TYPES = 'SET_SENSORS_TYPES';

export const SET_SENSORS_TASK_PENDING = 'SET_SENSORS_TASK_PENDING';
export const SET_SENSORS_TASK_FAILURE = 'SET_SENSORS_TASK_FAILURE';
export const SET_SENSORS_TASK_SUCCESSFUL = 'SET_SENSORS_TASK_SUCCESSFUL';

export const RESET_SENSORS = 'RESET_SENSORS';